import { queryOptions } from "@tanstack/react-query";
import {
  getClientGoalsFn,
  getUserCoachingAssignmentFn,
  getUserCoachingLogsFn,
  getUserDetailedActivityFn,
} from "./server";

export const getUserDetailedActivityOptions = (
  userId: string,
  limit?: number,
  offset?: number,
) =>
  queryOptions({
    queryKey: ["admin", "user-activity", userId, limit, offset],
    queryFn: () =>
      getUserDetailedActivityFn({ data: { userId, limit, offset } }),
  });

export const getUserCoachingAssignmentOptions = (userId: string) =>
  queryOptions({
    queryKey: ["admin", "coaching-assignment", userId],
    queryFn: () => getUserCoachingAssignmentFn({ data: { userId } }),
  });

export const getUserCoachingLogsOptions = (userId: string) =>
  queryOptions({
    queryKey: ["admin", "coaching-logs", userId],
    queryFn: () => getUserCoachingLogsFn({ data: { userId } }),
  });

export const getClientGoalsOptions = (userId: string) =>
  queryOptions({
    queryKey: ["admin", "client-goals", userId],
    queryFn: () => getClientGoalsFn({ data: { userId } }),
  });
